export const environment = {
  nomeAmbiente: '',
  production: true,
  apiUrl: '/reuse/api/publico',
  recaptchaKey: '6LfJVnMUAAAAANCRREtKuc1cDXnps1kZQ7WNoZLO'
};
